/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringLeasingContractDto } from '../../models/backend-monitoring-leasing-contract-dto';

export interface MonitoringScenariosLeasingsList$Params {
  scenario_id: number;
}

export function monitoringScenariosLeasingsList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosLeasingsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringLeasingContractDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosLeasingsList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringLeasingContractDto>>;
    }),
  );
}

monitoringScenariosLeasingsList.PATH = '/api/monitoring/scenarios/{scenario_id}/leasings/';
